import {
  Button,
  Typography,
  Paper,
  Grid,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useRef, useState } from 'react';
import Modal from '@mui/material/Modal';
import api from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { uploadXl } from '../../features/student/studentSlice';

const BulkUpload = ({ refreshStudents, setUploadStudents }) => {
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [successModal, setSuccessModal] = useState(false);
  const [count, setCount] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();
  const dispatch = useDispatch();

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setSelectedFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setUploadError('');
    }
  };

  async function getErrorsFile(Result) {
    try {
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/students/duplicate',
        method: 'POST',
        responseType: 'blob',
        data: Result,
      });
      console.log(fileResponse);
      const blob = new Blob([fileResponse.data], {
        type: fileResponse.headers['content-type'],
      });

      let filename = 'RejectedStudentsList.xlsx';
      const contentDisposition = fileResponse.headers['content-disposition'];
      const match = contentDisposition?.match(/filename="?(.+)"?/);
      if (match?.[1]) filename = match[1];

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed', err);
    }
  }

  const handleUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append('file', selectedFile);
    try {
      const response = await dispatch(
        uploadXl([formData, instituteType]),
      ).unwrap();
      inputRef.current ? (inputRef.current.value = '') : '';
      setLoading(false);
      if (response?.success) {
        setCount(response?.success);
        refreshStudents();
        setSuccessModal(true);
        setTimeout(() => {
          setSelectedFile(null);
          setUploadStudents(false);
        }, 3000);
      } else {
        setUploadError(
          'Error in Uploading,Check the downloaded File "RejectedStudentsList " for clarification',
        );
        setSelectedFile(null);
        getErrorsFile(response);
      }
    } catch {
      setUploadError('Error in Uploading');
    }
  };
  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <div>
          <div className='text-center'>
            <CircularProgress color='inherit' />
          </div>
          <div className='text-center'>Uploading ..</div>
        </div>
      </Backdrop>

      <Grid>
        <Grid item xs={12} className='flex justify-end'>
          <Button
            variant='text'
            startIcon={<DownloadIcon />}
            onClick={async () => {
              try {
                // Call Axios directly, bypass Redux for this side-effect
                const response = await api({
                  baseURL: process.env.REACT_APP_API_BASE_URL,
                  url: `/students/downloadTemplate/${instituteType}`,
                  method: 'GET',
                  responseType: 'blob',
                });

                const blob = new Blob([response.data], {
                  type: response.headers['content-type'],
                });

                let filename = 'sample-template.xlsx';
                const contentDisposition =
                  response.headers['content-disposition'];
                const match = contentDisposition?.match(/filename="?(.+)"?/);
                if (match?.[1]) filename = match[1];

                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                link.click();
                URL.revokeObjectURL(url);
              } catch (err) {
                console.error('Download failed', err);
              }
            }}
          >
            Download Sample Template
          </Button>
        </Grid>
        <Paper
          elevation={dragActive ? 6 : 2}
          sx={{
            p: 3,
            mb: 2,
            border: dragActive ? '2px solid #1976d2' : '2px dashed #ccc',
            textAlign: 'center',
            backgroundColor: dragActive ? '#f0f7ff' : 'inherit',
            cursor: 'pointer',
          }}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={() => inputRef.current.click()}
        >
          <CloudUploadIcon sx={{ fontSize: 40, color: '#1976d2', mb: 1 }} />
          <Typography>
            Drag &amp; drop your file here, or{' '}
            <span style={{ color: '#1976d2', textDecoration: 'underline' }}>
              browse
            </span>
          </Typography>
          <input
            type='file'
            accept='.xlsx,.csv'
            ref={inputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          {selectedFile && (
            <Typography sx={{ mt: 1 }}>
              Selected file: <b>{selectedFile.name}</b>
            </Typography>
          )}
        </Paper>
        <h6 className='text-red-600 '>{uploadError}</h6>
        <Grid item xs={12} className='flex  justify-end '>
          <Button
            loading={loading}
            loadingPosition='end'
            variant='contained'
            disabled={!selectedFile}
            onClick={() => {
              setLoading(true);
              handleUpload();
            }}
            className='flex justify-end normal-case'
          >
            Upload
          </Button>
        </Grid>
      </Grid>
      <Modal
        open={successModal}
        onClose={() => setSuccessModal(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <div className='bg-white fixed top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2 p-2 rounded-3xl'>
          <img src='/images/success.gif' className='rounded-full size-[70]  ' />
          <h5 className='text-center'>
            {`${count}  Student${count > 1 ? 's' : ''} Uploaded`} <br></br>
          </h5>
          <h5 className='text-center mb-4'> Successfully !</h5>
        </div>
      </Modal>
    </>
  );
};

export default BulkUpload;
